import React from 'react';
interface CTAButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  size?: 'default' | 'large';
  className?: string;
}
export function CTAButton({
  text,
  href,
  onClick,
  size = 'default',
  className = ''
}: CTAButtonProps) {
  const baseClasses = 'bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-200 inline-block text-center';
  const sizeClasses = size === 'large' ? 'px-12 py-6 text-xl' : 'px-8 py-4 text-lg';
  if (href) {
    return <a href={href} className={`${baseClasses} ${sizeClasses} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-77">
        {text}
      </a>;
  }
  return <button onClick={onClick} className={`${baseClasses} ${sizeClasses} ${className}`} data-id="element-78">
      {text}
    </button>;
}